const initFermentationArticle = (article) => {
  if (!article || article.dataset.sealFermentationArticleReady === 'true') return;
  article.dataset.sealFermentationArticleReady = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveals = [...article.querySelectorAll('[data-fermentation-article-reveal]')];

  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((element) => element.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
    );
    reveals.forEach((element) => observer.observe(element));
  }

  const related = article.querySelector('[data-fermentation-related]');
  const track = related?.querySelector('[data-related-track]');
  const cards = [...(related?.querySelectorAll('[data-related-card]') || [])];
  const previous = related?.querySelector('[data-related-previous]');
  const next = related?.querySelector('[data-related-next]');
  if (!track || cards.length < 2 || !previous || !next) return;

  let index = 0;
  let frame;

  const nearestIndex = () => {
    const left = track.getBoundingClientRect().left;
    return cards.reduce((nearest, card, cardIndex) => {
      const currentDistance = Math.abs(cards[nearest].getBoundingClientRect().left - left);
      const nextDistance = Math.abs(card.getBoundingClientRect().left - left);
      return nextDistance < currentDistance ? cardIndex : nearest;
    }, 0);
  };

  const update = (nextIndex) => {
    index = Math.max(0, Math.min(nextIndex, cards.length - 1));
    previous.disabled = index === 0;
    next.disabled = index === cards.length - 1;
  };

  const goTo = (nextIndex) => {
    const target = Math.max(0, Math.min(nextIndex, cards.length - 1));
    const trackRect = track.getBoundingClientRect();
    const cardRect = cards[target].getBoundingClientRect();
    track.scrollTo({
      left: track.scrollLeft + cardRect.left - trackRect.left,
      behavior: reduceMotion ? 'auto' : 'smooth',
    });
    update(target);
  };

  previous.addEventListener('click', () => goTo(index - 1));
  next.addEventListener('click', () => goTo(index + 1));
  track.addEventListener(
    'scroll',
    () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => update(nearestIndex()));
    },
    { passive: true }
  );

  update(0);
};

const initAllFermentationArticles = () => {
  document.querySelectorAll('[data-seal-fermentation-article]').forEach(initFermentationArticle);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllFermentationArticles);
} else {
  initAllFermentationArticles();
}

document.addEventListener('shopify:section:load', initAllFermentationArticles);
